import React, { FC, useMemo } from 'react';

import cn from 'classnames';

const monthNumberToString = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const weekNumberToString = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

interface CalenderProps {
  date: Date;
  className?: string;
}

const Calender: FC<CalenderProps> = ({ date, className }) => {
  const values = useMemo(
    () => ({
      month: monthNumberToString[date.getMonth()],
      date: date.getDate().toString().padStart(2, '0'),
      day: weekNumberToString[date.getDay()],
    }),
    [date]
  );

  return (
    <div className={cn('calender', className)}>
      <div className='calender__month-wrapper'>
        <span className='calender__month'>{values.month}</span>
      </div>
      <div className='calender__date'>{values.date}</div>
      <div className='calender__day'>{values.day}</div>
    </div>
  );
};

export default Calender;
